import { atom } from 'jotai';

export const boothIdAtom = atom<number | undefined>();
